import React from 'react'
import {Lang} from 'yougile-lang'
import {DealActivityDealItem, isDealActivityDealItem} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {
  getDealActivityColor
} from '@components/crm-activities-view/get-deal-activity-color'
import {cn} from '@containers/html-utils'
import {UserStickerState} from '@extensions/sticker/views-web/user/user-sticker-state'
import {getUserIdsInProjectByTask} from '../../../../crm-activities-view/activities-data/get-user-ids-in-project-by-board'
import {DealTimeDatePicker} from '../deal-time-input-panel/deal-time-date-picker'
import {getDealActivityById} from '../get-deal-activity'
import {TwMessageContainer, TwMessageIcon} from './common'
import {DealActivityDeleteButton} from './deal-activity-delete-button'
import {DealActivityDoneButton} from './deal-activity-done-button'
import {DealTimeLineMessageProps} from './types'

export const DealTimeLineActivityMessage = (
  props: DealTimeLineMessageProps<DealActivityDealItem>
) => {
  const {activity, deal} = props

  const users = getUserIdsInProjectByTask(deal)

  return (
    <TwMessageContainer
      key={activity.id}
      className={cn(activity.completed && 'opacity-50')}
    >
      <TwMessageIcon $bgWhite>
        <Icon icon="IconCustomBolt" />
      </TwMessageIcon>
      <div className="bg-primary text-14 px-12 pb-12 pt-10 rounded-12 shadow-xs group w-full">
        <div className="flex items-start gap-8 w-full">
          <div className="mt-3">
            <DealActivityDoneButton activity={activity} deal={deal} />
          </div>

          <div style={{wordBreak: 'break-word'}}>{activity.text}</div>
        </div>

        <div className="flex items-center ml-24 mt-8 max-h-16">
          <div className="flex gap-12 items-center">
            <DealTimeDatePicker
              color={getDealActivityColor(activity)}
              date={activity.deadline ?? Date.now()}
              setDate={date => {
                const dealActivity = getDealActivityById(deal, activity.id)
                if (isDealActivityDealItem(dealActivity)) {
                  dealActivity.deadline = date
                  deal.commit()
                }
              }}
              icon={false}
            />

            <UserStickerState
              avatarsClassName="flex items-center"
              users={activity.assigned ?? []}
              options={users}
              onChoose={assigned => {
                const dealActivity = getDealActivityById(deal, activity.id)
                if (isDealActivityDealItem(dealActivity)) {
                  dealActivity.assigned = assigned
                  deal.commit()
                }
              }}
              singleMode
              maxShow={3}
              title={Lang.msg.assigned}
              size={16}
            />
          </div>

          <DealActivityDeleteButton
            deal={deal}
            activity={activity}
            tooltip={Lang.msg.crm.rightPanel.dealHistory.deleteActivity}
            confirmationTitle={
              Lang.msg.crm.rightPanel.dealHistory.deleteActivity
            }
            confirmationDescription={
              Lang.msg.crm.rightPanel.dealHistory.deleteActivityConfirmation
            }
          />
        </div>
      </div>
    </TwMessageContainer>
  )
}
